<mat-card class="mat-elevation-z0 p-0">
  <mat-card-header>
    <mat-card-title>Privacy Policy</mat-card-title>
  </mat-card-header>
  <mat-card-content [style.overflow]="'auto'" [style.height.px]="'300'">
    <p>Lorem Ipsum</p>
    <br />
    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
    tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,
    quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
    consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse
    cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat
    non proident, sunt in culpa qui officia deserunt mollit anim id est laborum
    <br />
    <br />
    <p>Lorem ipsum</p>
  </mat-card-content>
  <mat-card-actions align="end">
    <button mat-button (click)="onCloseClick()">Close</button>
  </mat-card-actions>
</mat-card>
